import get from 'lodash.get';
import { emptyArray } from 'ui-components/default-props/empty';

export const selectSearchResults = (state) => get(state, 'searchResults', emptyArray);
